async function getMethods(baseConfig, requestConfig) {
    const url = `${baseConfig.apiUrl}/api/user/payment/method/${baseConfig.merchantId}/${requestConfig.userProfileId}?sessionId=${requestConfig.sessionId}&channelId=browser&method=${requestConfig.type}`;
    const request = await fetch(url);
    const response = await request.json();
    if (!response.methods) {
        return [];
    }
    return response.methods;
}

export { getMethods };
